import { useContext } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { getCompanyRating } from "../../selectors";
import { CompanyContext } from "../CompanyList/CompanyContext";
import { BaseColorBarRating } from "./BaseColorBarRating";

export const BaseColorBarRatingSection = ({ classNames }) => {
	const { company } = useContext(CompanyContext);
	const rating = useSelector((state) => getCompanyRating(state, { company }));

	if (!rating) return null;

	return (
		<div className={classNames?.wrapper}>
			<span className={classNames?.ratingLabel}>
				Overall <br /> Rating
			</span>

			<BaseColorBarRating rating={rating} classNames={classNames?.colorBar} />

			<span className={classNames?.ratingValue}>{rating}</span>
		</div>
	);
};

BaseColorBarRatingSection.propTypes = {
	classNames: PropTypes.object,
};
